import { Images } from "@/assets/images1";
import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const ResidentialIntroStepPage = () => {
  return (
    <div className={stepStyles.residentialIntro}>
      <div className={stepStyles.heroImageWrap}>
        <img
          src={Images.andyHoldingSign}
          alt="Andy holding sign"
          className={stepStyles.heroImage}
        />
      </div>
      <h3 className={stepStyles.residentialIntroTitle}>
        Residential Property Protest Documents Filing Process
      </h3>
      <p className={stepStyles.residentialIntroDescription}>
        We&apos;ll guide you through a simple step-by-step process to file your additional or
        supporting property documents.
      </p>

      <div className={stepStyles.residentialIntroStepsCard}>
        <p className={stepStyles.residentialIntroStep}>Step 1: Property Wear &amp; Tear</p>
        <p className={stepStyles.residentialIntroStep}>Step 2: Neighborhood Condition</p>
        <p className={stepStyles.residentialIntroStep}>Step 3: Sympathy Savings (Optional)</p>
        <p className={stepStyles.residentialIntroStep}>Step 4: Review &amp; Submit</p>
      </div>

      <div className={stepStyles.residentialIntroReminders}>
        <p className={stepStyles.residentialIntroRemindersTitle}>IMPORTANT REMINDERS:</p>
        <ul className={stepStyles.residentialIntroRemindersList}>
          <li>Upload clear documentation showing property and neighborhood conditions</li>
          <li>Take high-quality photos that clearly show any issues or damage</li>
          <li>Document both interior and exterior conditions that may affect property value</li>
          <li>Include photos of comparable properties in your neighborhood if applicable</li>
        </ul>
      </div>
    </div>
  );
};
